const RELATIVE_TIME = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

const DIVISIONS: Array<{ amount: number; unit: Intl.RelativeTimeFormatUnit }> =
  [
    { amount: 60, unit: 'second' },
    { amount: 60, unit: 'minute' },
    { amount: 24, unit: 'hour' },
    { amount: 7, unit: 'day' },
    { amount: 4.34524, unit: 'week' },
    { amount: 12, unit: 'month' },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' },
  ]

/**
 * Human relative time, e.g. "in 3 days" / "2 hours ago". `from` defaults to now;
 * pass it explicitly in tests so the output is deterministic.
 */
export function formatRelativeTime(target: Date, from: Date = new Date()) {
  let duration = (target.getTime() - from.getTime()) / 1000
  for (const division of DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return RELATIVE_TIME.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }
  return RELATIVE_TIME.format(Math.round(duration), 'year')
}
